<template>
  <Modal v-model="visible" title="请选择要提现的期数" :mask-closable="false" :footer-hide="true" @on-cancel="defult" width="1100px" class="modelWithdraw">
    <!-- 工具栏 -->
    <div class="tools-box">
      <div class="left-box">
        <Checkbox v-model="isAll" @on-change="changeSelectAll">全选</Checkbox>
        <span class="text"
          >已选<span>{{ isAll ? total : selectArr.length }}</span
          >/{{ tableData.length }}项</span
        >
        <span class="text">合计提现{{ totalWithdrawalMoney.toFixed(2) }}元</span>
      </div>
    </div>
    <loading :isShow="listLoading" />
    <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
      <template slot-scope="{ row }" slot="action">
        <span class="table-btn" @click="detailsPage(row)">查看明细</span>
      </template>
    </Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="changePage" class="page-size" />
    <div class="ivu-modal-footer">
      <Button type="text" @click="defult()">取消</Button>
      <Button type="primary" @click="nextStep">下一步</Button>
    </div>

    <!-- 业务员提现弹窗 -->
    <withdrawalModal ref="withdrawalModal" @ok='withdrawalSuccess'></withdrawalModal>
  </Modal>
</template>

<script>
import { mapState } from 'vuex';
import { common, pageTool } from '@/api/mixins';
import { filterTime } from '@/api/filter';
import withdrawalModal from "./withdrawalModal";

export default {
  components: {withdrawalModal},
  mixins: [common, pageTool],
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      canWithdraw:null,
      isAll: false, //全部
      selectArr: [], //表格选择的数据
      allIds: [], //全选所有的id
      visible: false,
      tableData: [],
      totalWithdrawalMoney: 0.00,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '结算周期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 80
        },
        {
          title: '结算保费',
          align: 'center',
          key: 'policyFee',
          minWidth: 130
        },
        {
          title: '税前收入（元）',
          align: 'center',
          key: 'totalIncome',
          minWidth: 130
        },
        {
          title: '实际收入（元）',
          align: 'center',
          key: 'income',
          minWidth: 130
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 130,
          fixed: 'right'
        }
      ]
    };
  },
  methods: {
    defult() {      
      this.visible = false;
      this.isAll = false;
    },

    open(canWithdraw) {
      this.selectArr = [];
      this.canWithdraw = canWithdraw;
      this.totalWithdrawalMoney = 0.00;
      this.visible = true;
      this.getDataList();
    },

    withdrawalSuccess() {
      this.selectArr = [];
      this.isAll = false;
      this.totalWithdrawalMoney = 0.00;
      this.getDataList();
    },

    getDataList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/userCashWithdrawLog/waitWithdrawal',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          res.data.forEach(item => {
            if (!this.isAll) {
              this.selectArr.forEach(item2 => {
                if (item.id == item2.id) {
                  item._checked = true;
                }
              });
            } else {
              this.allIds.forEach(item2 => {
                if (item.id == item2) {
                  item._checked = true;
                }
              });
            }
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
          this.$emit('ok-withdrawal');
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 全部选择
    changeSelectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.$set(this, 'tableData', tableData);
      if (this.isAll) {
        this.getAllTotalWithdrawalMoney();
        this.selectArr = [];
      } else {
        this.totalWithdrawalMoney = 0.0;
        this.allIds = [];
        this.selectArr = [];
      }
    },

    // 全选合计提现
    getAllTotalWithdrawalMoney() {
      this.$http({
        url: '/buz/userCashWithdrawLog/waitWithdrawalTotal',
        type: 'POST',
        data: {}
      }).then(res => {
        this.totalWithdrawalMoney = res.data.total;
        this.allIds = res.data.settleNumberList;
      });
    },

    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.reportId); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.reportId); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.reportId) && !selectIds.includes(item.reportId)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.reportId);
        } else if (!ids.includes(item.reportId) && selectIds.includes(item.reportId)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.reportId), 1);
          selectIds.splice(selectIds.indexOf(item.reportId), 1);
        }
      });
      // 计算合计提现
      const values = this.selectArr.map(item => item.income);
      this.totalWithdrawalMoney = values.reduce((accumulator, value) => accumulator + value, 0);
    },

    // 明细
    detailsPage(row) {
      this.openPageTabTags('/financialManage/myIncome/detail', {
        reportId: row.reportId,
        userId: this.userInfo.userid,
        title: `${filterTime(row.settlementDate, 'YYYY-MM-DD')}结算单明细`
      });
    },

    async nextStep() {
      if (!this.selectArr.length && !this.isAll) {
        this.$notice.msg('请勾选需要提现的数据');
        return;
      }
      let ids = [];
      if (!this.isAll) {
        this.selectArr.forEach(item => {
          ids.push(item.reportId);
        });
      } else {
        ids = this.allIds;
      }
      this.$refs.withdrawalModal.open(ids, this.totalWithdrawalMoney.toFixed(2), this.canWithdraw);
    },

    changePage(pageNum) {
      this.pageNum = pageNum;
      this.getDataList();
    }
  }
};
</script>

<style lang="scss" scoped>
.modelWithdraw {
  /deep/ .ivu-modal-header {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  /deep/ .ivu-modal-header-inner {
    font-size: 14px;
  }
  /deep/ .ivu-icon-ios-close {
    font-size: 30px;
    color: #a8adb7;
  }
}
.text {
  margin-left: 10px;
  margin-right: 20px;
}
.page-size {
  text-align: center;
  margin-top: 20px;
}
.ivu-modal-footer {
  margin-top: 30px;
  padding-bottom: 10px;
}
</style>
